var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { t } from 'i18next';
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { GetVehicleInspectionListURL, USER_PROFILE_DATA, ViewEstimateUrl, createSEUrl } from "../../api/url";
import CancelSuccessfullyPopup from '../../components/molecules/cancelSuccessfullyPopup';
import CancelDocumentModal from '../../components/templates/cancelDocumentModal';
import { ECancelDocSystemName, EMenuFeature, EMenuNames, LOCAL_STORAGE_KEYS, Module, StatusEnum, isModuleConfig } from "../../constants";
import { setDocDataUpdated, setUpdatedModuleSectionByChannel, showLoader } from "../../redux/commonSlice";
import { createAPI, getByIdAPI, resetState, setState } from "../../redux/crudSlice";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { getLocalStorageItem } from "../../utils/storageHelper";
import useAnalyticsEventTracker from '../../utils/useAnalyticsEventTracker';
import { getCTAList } from '../../utils/utils';
import List from "../commonViews/list/list";
var listVariants = ["MY_INSPECTION", "ALL_INSPECTION"];
var assignMenus = [
// { DisplayName: "Generate Estimate", Name: "GenerateEstimate" },
];
var reassignMenus = ["Reassign", "Reschedule", "Cancel", "Create Draft job card"];
var VehicleInspectionList = function () {
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _a = useAppSelector(function (state) { return state.crud; }), GetVehicleList = _a.GetVehicleList, isLoadingGetVehicleList = _a.isLoadingGetVehicleList;
    var _b = useState([]), appointmentList = _b[0], setAppointmentList = _b[1];
    var _c = useState("My Inspection"), selectedListVariant = _c[0], setSelectedListVariant = _c[1];
    var _d = useState(false), isAssignModalOpen = _d[0], setIsAssignModalOpen = _d[1];
    var _e = useState(""), assignValue = _e[0], setAssignValue = _e[1];
    var _f = useState(false), isRescheduleModalOpen = _f[0], setIsRescheduleModalOpen = _f[1];
    var _g = useState(false), isCancelModalOpen = _g[0], setIsCancelModalOpen = _g[1];
    var _h = useState(null), anchorEl = _h[0], setAnchorEl = _h[1];
    var _j = useState({}), clickIndexItem = _j[0], setClickIndexItem = _j[1];
    var _k = useState([]), menus = _k[0], setMenus = _k[1];
    // const storedMenuFeatures = getLocalStorageItem(LOCAL_STORAGE_KEYS.MENU_FEATURE)
    var storedAllMenuFeatures = getLocalStorageItem(LOCAL_STORAGE_KEYS.ASSIGNED_MENUS);
    var _l = useState(''), inspectionCode = _l[0], setInspectionCode = _l[1];
    var _m = useState(false), cancelledSuccessfulPopup = _m[0], setCancelledSuccessfulPopup = _m[1];
    var trackButtonClick = useAnalyticsEventTracker("VehicleInspectionList");
    var _o = useState({
        status: [],
        vehicleList: [],
        serviceType: [],
        advisorList: []
    }), filterList = _o[0], setFilterList = _o[1];
    var open = Boolean(anchorEl);
    var userData = getLocalStorageItem(USER_PROFILE_DATA);
    useEffect(function () {
        dispatch(setDocDataUpdated(false));
    }, []);
    var inspectionFeatures = getCTAList(storedAllMenuFeatures, EMenuNames.Inspection);
    var initialData = function (index) {
        var _appointmentList$inde;
        if ((_appointmentList$inde = appointmentList[index]) !== null && _appointmentList$inde !== void 0 && _appointmentList$inde.AssignedEmployeeId) {
            var _appointmentList$inde2;
            if (((_appointmentList$inde2 = appointmentList[index]) === null || _appointmentList$inde2 === void 0 ? void 0 : _appointmentList$inde2.Key) == StatusEnum.Inward) {
                var reassign = ["Reassign"];
                setMenus(reassign);
            }
            else {
                setMenus(reassignMenus);
            }
        }
        else {
            if (appointmentList[index] == StatusEnum.Inward) {
                var assign = ["Assign"];
                setMenus(assign);
            }
            else {
                setMenus(assignMenus);
            }
        }
    };
    var onClickCreateVehicleInspection = function () {
        trackButtonClick("ButtonClickEvent", "onCreate_VI_Click", undefined);
        dispatch(resetState(['AssociateCustomerId', "documentDetailsGetById", "preDocumentFetch", "filterValue", "getCustomerInfo", "getStoredJobItems", "getModuleHeaderCount", "customerComplaintDataImageAndAudio", "createVehicleInspectionData", "customerDetailsTrnalsteToJob", "RiderDetailsList", "ModuleDetailsGetById", "savedJobItemCreateFlow"]));
        navigate('/create-inspection');
    };
    var onClickVehicleInspectionCard = function (item) {
        dispatch(resetState(['AssociateCustomerId', "documentDetailsGetById", "preDocumentFetch", "filterValue", "getCustomerInfo", "getStoredJobItems", "getModuleHeaderCount", "customerComplaintDataImageAndAudio", "createVehicleInspectionData", "customerDetailsTrnalsteToJob", "RiderDetailsList", "ModuleDetailsGetById", "savedJobItemCreateFlow"]));
        navigate("/inspection-Detail/".concat(item.InspectionId));
    };
    var viewEstimateFun = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _result$payload, _result$payload3, _result$payload4, requestBody, result, _result$payload2, _result$payload5;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    requestBody = {
                        "PreJobCardDocumentId": clickIndexItem === null || clickIndexItem === void 0 ? void 0 : clickIndexItem.InspectionId
                    };
                    return [4 /*yield*/, dispatch(getByIdAPI({
                            key: '',
                            url: ViewEstimateUrl,
                            request: requestBody
                        }))];
                case 1:
                    result = _a.sent();
                    if (!(result !== null && result !== void 0 && (_result$payload = result.payload) !== null && _result$payload !== void 0 && (_result$payload = _result$payload.data) !== null && _result$payload !== void 0 && _result$payload.PreJobCardDocumentId)) {
                        alert("PreJobCardDocument ID : ".concat(result === null || result === void 0 || (_result$payload2 = result.payload) === null || _result$payload2 === void 0 || (_result$payload2 = _result$payload2.data) === null || _result$payload2 === void 0 ? void 0 : _result$payload2.PreJobCardDocumentId, " "));
                    }
                    if (result !== null && result !== void 0 && (_result$payload3 = result.payload) !== null && _result$payload3 !== void 0 && _result$payload3.success && (result === null || result === void 0 || (_result$payload4 = result.payload) === null || _result$payload4 === void 0 ? void 0 : _result$payload4.statusCode) == 200) {
                        dispatch(setUpdatedModuleSectionByChannel([]));
                        navigate("/serviceEstimate-details/".concat(result === null || result === void 0 || (_result$payload5 = result.payload) === null || _result$payload5 === void 0 || (_result$payload5 = _result$payload5.data) === null || _result$payload5 === void 0 ? void 0 : _result$payload5.PreJobCardDocumentId), {
                            state: {
                                fromRoute: '/inspection'
                            }
                        });
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var handleMenusClick = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            console.log("data", data);
            console.log("clickIndexItem", clickIndexItem);
            dispatch(setState({
                key: "documentDetailsGetById",
                value: {}
            }));
            if (clickIndexItem.Key === "Completed") {
                if ((data === null || data === void 0 ? void 0 : data.Name) == EMenuFeature.ViewEstimate) {
                    viewEstimateFun();
                }
                else if ((data === null || data === void 0 ? void 0 : data.Name) == EMenuFeature.Cancel) {
                    setIsCancelModalOpen(true);
                }
                else {
                    VIGenerateEstimateFun(clickIndexItem);
                }
            }
            if (clickIndexItem.Key === StatusEnum.Converted) {
                if ((data === null || data === void 0 ? void 0 : data.Name) == EMenuFeature.ViewEstimate) {
                    viewEstimateFun();
                }
                else if ((data === null || data === void 0 ? void 0 : data.Name) == EMenuFeature.Cancel) {
                    setIsCancelModalOpen(true);
                }
                else {
                    VIGenerateEstimateFun(clickIndexItem);
                }
            }
            if (clickIndexItem.Key === "Open") {
                if ((data === null || data === void 0 ? void 0 : data.Name) == EMenuFeature.Cancel) {
                    setIsCancelModalOpen(true);
                }
            }
            return [2 /*return*/];
        });
    }); };
    var VIGenerateEstimateFun = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var _createEstimateRespon, _createEstimateRespon2, requestBody, createEstimateResponse;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    trackButtonClick("ButtonClickEvent", "Generate_Estimate_Click", undefined);
                    requestBody = {
                        InspectionId: data.InspectionId
                    };
                    dispatch(showLoader({
                        isLoaderOpen: true
                    }));
                    return [4 /*yield*/, dispatch(createAPI({
                            key: "",
                            url: createSEUrl,
                            request: requestBody
                        }))];
                case 1:
                    createEstimateResponse = _a.sent();
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                    if (createEstimateResponse !== null && createEstimateResponse !== void 0 && (_createEstimateRespon = createEstimateResponse.payload) !== null && _createEstimateRespon !== void 0 && _createEstimateRespon.success && createEstimateResponse !== null && createEstimateResponse !== void 0 && (_createEstimateRespon2 = createEstimateResponse.payload) !== null && _createEstimateRespon2 !== void 0 && (_createEstimateRespon2 = _createEstimateRespon2.data) !== null && _createEstimateRespon2 !== void 0 && _createEstimateRespon2.EstimateId) {
                        // setFinishPopup(false)
                        // navigate(`/vehicleInspection-details/${props.parentModuleDocumentId}`)
                        dispatch(setUpdatedModuleSectionByChannel([]));
                        navigate("/serviceEstimate-details/".concat(createEstimateResponse.payload.data.EstimateId, "/inspection/").concat(createEstimateResponse.payload.data.ParentId));
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var onCancelPopupClick = function (value) {
        setIsCancelModalOpen(value);
        setAnchorEl(null);
    };
    var onCancelInspectionClick = function (result) { return __awaiter(void 0, void 0, void 0, function () {
        var _result$payload6, _result$payload7, _result$payload8;
        return __generator(this, function (_a) {
            trackButtonClick("ButtonClickEvent", "onCancelInspectionClick", undefined);
            if ((result === null || result === void 0 || (_result$payload6 = result.payload) === null || _result$payload6 === void 0 ? void 0 : _result$payload6.statusCode) == 200 || result !== null && result !== void 0 && (_result$payload7 = result.payload) !== null && _result$payload7 !== void 0 && _result$payload7.success) {
                dispatch(setState({
                    key: "menuValue",
                    value: 'cancel'
                }));
                onCancelPopupClick(false);
                navigate("/inspection");
                setInspectionCode((_result$payload8 = result.payload) === null || _result$payload8 === void 0 || (_result$payload8 = _result$payload8.data) === null || _result$payload8 === void 0 ? void 0 : _result$payload8.Code);
                setCancelledSuccessfulPopup(true);
            }
            return [2 /*return*/];
        });
    }); };
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(List, {
        getModuleList: GetVehicleList,
        storeModuleName: "GetVehicleList",
        pageTitle: t("HEADER_TITLE_VI"),
        moduleListUrl: GetVehicleInspectionListURL,
        listVariants: listVariants
        // assignMenus={assignMenus}
        // reassignMenus={reassignMenus}
        ,
        menusFeatures: inspectionFeatures,
        onClickCard: onClickVehicleInspectionCard,
        onClickCreateModule: onClickCreateVehicleInspection,
        handleMenusClick: handleMenusClick,
        itemData: function (item) { return setClickIndexItem(item); },
        createButtonText: Module === isModuleConfig.Bajaj ? t('Create draft job card') : t('Create Inspection'),
        moduleName: "Inspection",
        loadingState: isLoadingGetVehicleList,
        noDataTitle: Module === isModuleConfig.Bajaj ? t("No draft job card found") : t("No vehicle inspection found"),
        noDataSubTitle: Module === isModuleConfig.Bajaj ? t("No draft job card created yet, Please create.") : t("No vehicle inspection created yet, Please create."),
        isMoreMenuVisible: false,
        isCreateButton: Module === isModuleConfig.Bajaj ? false : true
    }), isCancelModalOpen && /*#__PURE__*/ React.createElement(CancelDocumentModal, {
        cancelPopup: isCancelModalOpen,
        data: clickIndexItem,
        title: t("CANCEL_INSPECTION"),
        subTitle: t("CANCEL_INSPECTION_CONFIRMATION_MSG"),
        onCancelPopup: function (value) { return onCancelPopupClick(value); },
        onCancelClick: function (result) { return onCancelInspectionClick(result); },
        SystemName: ECancelDocSystemName.Inspection
    }), cancelledSuccessfulPopup && /*#__PURE__*/ React.createElement(CancelSuccessfullyPopup, {
        documentCode: inspectionCode,
        successfulPopup: cancelledSuccessfulPopup,
        onClosePopup: function (value) {
            setCancelledSuccessfulPopup(value);
            navigate("/inspection");
        },
        title: t('Successfully cancelled!'),
        subTitle: t('INSPECTION_CANCEL_SUCCESS_MESSAGE', {
            documentCode: inspectionCode
        })
    }));
};
export default VehicleInspectionList;
